import type { ReactNode } from 'react';
import { Chip, type EstadoChip } from '../../componentes/Chip';
import { Icono } from '../../componentes/Icono';
import type { NombreIcono } from '../../componentes/iconos';

/**
 * Una línea de la tarjeta de «Mi cuenta» (1.8): etiqueta gris, valor en negrita, una línea de ayuda opcional y, a la
 * derecha, la etiqueta de estado y el botón fantasma («Cambiar», «Reenviar», «Quitar» en rojo…). En móvil el botón baja
 * bajo el texto.
 */
export interface BotonFila {
    texto: string;
    icono: NombreIcono;
    onClick: () => void;
    rojo?: boolean;
    desactivado?: boolean;
}

export function Fila({
    etiqueta,
    valor,
    sub,
    icono,
    chip,
    botones = [],
    fuerte = false,
    extra,
}: {
    etiqueta: string;
    valor: ReactNode;
    sub?: string | null;
    icono?: NombreIcono;
    chip?: { texto: string; estado: EstadoChip } | null;
    botones?: readonly BotonFila[];
    /** Etiqueta en negro (las sesiones: el dispositivo arriba). */
    fuerte?: boolean;
    extra?: ReactNode;
}) {
    return (
        <div className="rv-cuenta__fila">
            {icono !== undefined && (
                <span className="rv-cuenta__icono" aria-hidden="true">
                    <Icono nombre={icono} />
                </span>
            )}
            <div className="rv-cuenta__textos">
                <span className={fuerte ? 'rv-cuenta__k rv-cuenta__k--fuerte' : 'rv-cuenta__k'}>{etiqueta}</span>
                <span className="rv-cuenta__v">{valor}</span>
                {sub != null && sub !== '' && <span className="rv-cuenta__sub">{sub}</span>}
            </div>
            {(chip != null || botones.length > 0 || extra !== undefined) && (
                <div className="rv-cuenta__lado">
                    {chip != null && <Chip estado={chip.estado}>{chip.texto}</Chip>}
                    {extra}
                    {botones.map((b) => (
                        <button key={b.texto} type="button" className={`rv-b rv-b-fan rv-cuenta__boton${b.rojo === true ? ' rv-cuenta__boton--rojo' : ''}`} disabled={b.desactivado} onClick={b.onClick}>
                            <Icono nombre={b.icono} />
                            <span>{b.texto}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
